import warningIcon from "@assets/images/warning-red.svg";
import { Box, Button, Dialog, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import { useIntl } from "react-intl";

const useStyles = makeStyles(
  theme => ({
    title: {
      color: "#333",
      marginRight: "4px",
      fontFamily: "SCG",
      fontSize: "20px",
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "26px"
    },
    checkCircleimg: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    button: {
      alignSelf: "center",
      backgroundColor: "#FF2600",
      borderRadius: "4px",
      width: "100%", // Set the width to 100% to ensure it doesn't extend beyond the dialog
      maxWidth: "315px", // Limit the maximum width if needed
      height: "48px",
      marginTop: "30px",
      marginBottom: "28px"
    },
    buttonTitle: {
      fontSize: "18px",
      color: "white"
    },
    message: {
      justifyContent: "center",
      alignItems: "center",
      fontFamily: "SCG",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "24px",
      display: "flex"
    },
    dialog: {
      width: "420px",
      padding: theme.spacing(4),
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.25)",
      borderRadius: "16px",
      display: "flex",
      flexDirection: "column",
      minHeight: "200px", // Set a min-height to prevent the dialog from collapsing
      justifyContent: "space-between"
    },
    titles: {
      fontSize: "20px",
      fontWeight: 700
    },
    succcesType: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginTop: "5px"
    }
  }),
  { name: "DialogWarning" }
);

export interface Props {
  title: string;
  isOpen: boolean;
  okText: string;
  onClose: () => void;
  content: string;
}

const DialogWarning = ({ isOpen, onClose, title, content, okText }: Props) => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <Dialog
      open={isOpen}
      keepMounted
      onClose={onClose}
      PaperProps={{
        style: { borderRadius: 16 }
      }}
    >
      <Box className={classes.dialog}>
        <div className={classes.checkCircleimg}>
          <img
            src={warningIcon}
            alt="Warning Icon"
            style={{ width: "40px", height: "40px" }}
          />
        </div>
        <div className={classes.succcesType}>
          <Typography className={classes.titles}>
            {intl.formatMessage(
              {
                defaultMessage: "{title}",
                description: "title"
              },
              { title }
            )}
          </Typography>
        </div>
        <div>
          <Typography className={classes.message}>
            {intl.formatMessage(
              {
                defaultMessage: "{content}",
                description: "content"
              },
              { content }
            )}
          </Typography>
        </div>

        <Button className={classes.button} onClick={onClose}>
          <Typography className={classes.buttonTitle}>
            {intl.formatMessage(
              {
                defaultMessage: "{okText}",
                description: "Close"
              },
              { okText }
            )}
          </Typography>
        </Button>
      </Box>
    </Dialog>
  );
};

export default DialogWarning;
